import { Stack, useTheme } from "@mui/material";
import type { ReactNode } from "react";

interface DictationPanelProps {
  /** A `DictationView`. */
  children: ReactNode;
}

/**
 * The dictation box an editor shows while dictating (the Notes & time mock):
 * transcript on top, ✓ / ✗ and the waveform along the bottom. Fills the
 * space it's given — put it in an editor's `overlay` slot.
 */
export const DictationPanel = ({ children }: DictationPanelProps) => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        flex: 1,
        justifyContent: "space-between",
        gap: "8px",
        padding: "8px 12px",
        backgroundColor: theme.palette.neutral["005"],
      }}
    >
      {children}
    </Stack>
  );
};
